import React from 'react';
import { connect } from "react-redux";
import { browserHistory as history } from 'react-router';
import { TextField, PrimaryButton, Link, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import helpers from '../../helpers';
import { login } from '../../axios/auth';
import axios from 'axios';
import config from '../../config';

export class ChangePasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            changed: false
        }
    }

    dismissMsg() {
        this.setState({
            msg: ''
        });
    }

    submit() {
        var password = this.refs.password.value;
        var password2 = this.refs.rePassword.value;
        if (!password) {
            this.setState({
                msg: 'Please enter your password'
            });
        }
        else if (password != password2) {
            this.setState({
                msg: 'Two different password'
            });
        }
        else {
            this.setState({
                msg: ''
            });

            let authprovider = "auth";
            if(this.props.authprovider)
                authprovider = this.props.authprovider;

            axios.post(config.apiUrl + '/'+authprovider+'/resetPassword', {
                password: password
            })
            .then(({data}) => {
                this.setState({
                    changed: true
                });
            })
            .catch(err => {
                this.setState({
                    msg: helpers.axiosError(err)
                });
            });
        }
    }

    render() {
        const { msg, changed } = this.state;
        const { error } = this.props.auth;

        return (changed ?
            <MessageBar messageBarType={MessageBarType.success}>
                Updated your password
            </MessageBar>:
            <div>
                <TextField ref="password" label="New Password" type="password"></TextField>
                <TextField ref="rePassword" label="Re-enter Password" type="password"></TextField>
                {(msg || (error && error.message)) &&
                    <MessageBar messageBarType={MessageBarType.error} onDismiss={() => this.dismissMsg()}>
                        {msg || (error && error.message)}
                    </MessageBar>
                }
                <div>
                    <PrimaryButton className="mt-5" onClick={() => this.submit()}>Save</PrimaryButton>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, own_props) {
  return {
      auth: state.auth
  }
}

export default connect(mapStateToProps)(ChangePasswordForm);


// WEBPACK FOOTER //
// ./client/components/common/ChangePasswordForm.js